<template>
    <span
        class="tachograph-day-km"
        :class="{ 'tachograph-day-km--estimated': isEstimated }"
        v-b-tooltip.noninteractive.hover.top
        :title="tooltipText"
    >
        <span>{{ kmValue }}</span>
        <feather-icon v-if="isEstimated" icon="AlertCircleIcon" size="11" class="ml-25"></feather-icon>
    </span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    props:{
        field:[Object,String]
    },
    computed:{
        kmValue(){
            if(this.field && this.field.Km !== undefined && this.field.Km !== null && this.field.Km !== ''){
                return this.field.Km
            }

            return '-'
        },
        isEstimated(){
            return !!(this.field && this.field.DisplayMode === 'utc_plus_3' && this.kmValue !== '-')
        },
        tooltipText(){
            if(this.isEstimated){
                return 'Takograf verisinde kilometre saat bloklarına ayrışmadığı için UTC+3 görünümünde gün bazında yaklaşık yorumlanır.'
            }

            return ''
        }
    }
}
</script>

<style scoped>
.tachograph-day-km{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    min-width:2rem;
}

.tachograph-day-km--estimated{
    color:#0891b2;
    cursor:help;
    font-weight:700;
    text-decoration:underline dotted rgba(8,145,178,.45);
    text-underline-offset:2px;
}
</style>
